import { Theme } from '@mui/material/styles'

import { onHover, selectedState } from '../interaction'

// ----------------------------------------------------------------------

export default function Menu(theme: Theme) {
  return {
    MuiMenu: {
      styleOverrides: {
        root: {
          zIndex: 2000000001,
        },
        // Options sit inset from the menu's edge, as in GroupedMenu's searchable menus: a hover or
        // selection then reads as a rounded chip of its own, not a band across the whole menu.
        list: {
          padding: theme.spacing(1),
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          // The shared ring (Focus.ts) sits 2px outside the control. An option fills its menu's
          // width and sits inside a scrolling list, which clips anything outside it, so the ring
          // goes inside the option's own edge here and is seen whole.
          '&.Mui-focusVisible, &:focus-visible': { outlineOffset: -2 },
          ...onHover({ backgroundColor: theme.palette.action.hover }),
          // The kit's selected state. A menu option has no checkbox beside it, so medium weight is
          // the second cue.
          '&.Mui-selected': {
            ...selectedState(theme),
            fontWeight: theme.typography.fontWeightMedium,
          },
        },
      },
    },
  }
}
